import { sendRequestWithAuth } from '../common/sendRequest';
import * as settings from './settings';
import { getFavoritesRequestParams } from '../common/favoritesServiceHelper';

export function getClients() {
  return sendRequestWithAuth(
    settings.ServerURL, {
      method: 'POST',
      body: JSON.stringify({
        operation: 'get_clients'
      })
    }
  );
}

export function getClientById(clientId) {
  return sendRequestWithAuth(
    settings.ServerURL, {
      method: 'POST',
      body: JSON.stringify({
        operation: 'get_client_by_id',
        id: clientId,
      })
    }
  );
}

export function addClient(legalForm, name, taxId, contactPerson, e_mail, phone, legalAddress = null) {
  return sendRequestWithAuth(
    settings.ServerURL, {
      method: 'POST',
      body: JSON.stringify({
        operation: 'add_client',
        legal_form: legalForm,
        name,
        tax_id: taxId,
        contact_person: contactPerson,
        e_mail,
        phone,
        legal_address: legalAddress
      })
    }
  );
}

export function updateClient(id, legalForm, name, taxId, contactPerson, e_mail, phone, legalAddress = null) {
  return sendRequestWithAuth(
    settings.ServerURL, {
      method: 'POST',
      body: JSON.stringify({
        operation: 'update_client',
        id,
        legal_form: legalForm,
        name,
        tax_id: taxId,
        contact_person: contactPerson,
        e_mail,
        phone,
        legal_address: legalAddress
      })
    }
  );
}

export function getClientsHistory(clientId = null) {
  return sendRequestWithAuth(
    settings.ServerURL, {
      method: 'POST',
      body: JSON.stringify({
        operation: 'get_client_history',
        client_id: clientId
      })
    }
  ).then(history => history)
    .catch(error => {
      throw error
    });
}

export function getClientsHistoryById(clientId = null) {
  return sendRequestWithAuth(
    settings.ServerURL, {
      method: 'POST',
      body: JSON.stringify({
        operation: 'get_client_history_by_id',
        id: clientId
      })
    }
  )
}

export function addClientToFavorites(clientId = null) {
  return sendRequestWithAuth(
    settings.ServerURL, getFavoritesRequestParams(
      'client', 'add', clientId
    )
  );
}

export function removeClientFromFavorites(clientId = null) {
  return sendRequestWithAuth(
    settings.ServerURL, getFavoritesRequestParams(
      'client', 'remove', clientId
    )
  );
}



// WEBPACK FOOTER //
// ./src/services/clients.js